import React from "react";
import { Link } from "react-router-dom";
import { slugToCountryPathname } from "../../utils/strings";
import { ArrowRight } from "@speedoc/design-assets/build/icons/index.js";
import { useMediaQuery } from "react-responsive";

const StaffShowcase = ({ content }) => {
  const isTablet = useMediaQuery({ query: "(max-width: 1100px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  return (
    <div id="staffShowcase">
      <div className="title">{content.title}</div>
      <div className="description">{content.description}</div>
      <div className="images">
        {content.imagesList.map((image, i) => (
          <img
            key={i}
            className={`image-${i} ${isTablet && !isMobile ? "smaller" : ""}`}
            src={image.media?.url}
            alt="staff"
          />
        ))}
      </div>
      <div className="cards">
        {content.cards.map((card, i) => (
          <div key={i} className={`card card-${i} ${isTablet && !isMobile ? "smaller" : ""}`}>
            <div className="title">{card.title}</div>
            <div className="text">{card.text}</div>
          </div>
        ))}
      </div>
      <div className="linkBox">
        <div className="title">{content.linkBox.title}</div>
        <Link to={slugToCountryPathname((content?.linkBox?.link?.length > 0 && content.linkBox.link[0].path) ?? "")}>
          <div className="link">
            {content?.linkBox?.link?.length > 0 && content.linkBox.link[0].text}
            <ArrowRight />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default StaffShowcase;
